import React from 'react';
import { IThspianPlaylist } from '../../../types/global/helper';
import { Box } from '@mui/material';
import CustomLazyLoadImage from '../../Image/CustomLazyLoadImage';

export interface IPlaylistCard {
    size?: number;
    playlist: IThspianPlaylist;
}

export const PlaylistCard: React.FC<IPlaylistCard> = ({ playlist, size }) => {
    const maxVisibleIcons = 3; // Limit the number of visible icons to 3
    const ICON_SIZE = size ?? 25; // Base icon size

    return (
        <Box
            sx={{
                position: 'relative',
                display: 'flex',
                width: ICON_SIZE, // Adjust based on the size of the largest icon
                height: ICON_SIZE - 10,
            }}>
            {playlist.projects
                .slice(0, maxVisibleIcons)
                .filter(p => p && p.project && !!p.feature_image)
                .map((project, index) => {
                    const size = index < 1 ? ICON_SIZE : ICON_SIZE - 8; // Decrease size by 10px for each subsequent icon
                    const zIndex = maxVisibleIcons - index; // Control z-index to keep them stacked correctly

                    return (
                        <CustomLazyLoadImage
                            key={project._id}
                            src={project.feature_image}
                            style={{
                                height: size - 20,
                                width: size,
                                zIndex: zIndex,
                                position: index > 0 ? 'absolute' : 'relative', // Use relative position for stacking
                                border: `0.1px solid white`,
                                borderRadius: '3px',
                                objectFit: 'cover',
                                opacity: index < 1 ? 1 : 0.5,
                                ...(index === 1 && { bottom: '22px', left: '3px', right: '2px' }),
                                ...(index === 2 && { bottom: '25px', left: '3px', right: '2px' }),
                            }}
                            alt={project.title}
                        />
                    );
                })}
        </Box>
    );
};
